module.exports = __webpack_public_path__ + "assets/img/202112-5W.313dfd56.png";